import React from 'react'
import style from "./Home2.module.css"
export const Elements = () => {
  return (
    <div>

<div className={style.transform}>
          <div>
              <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_400,q_auto:eco,dpr_1,f_auto,fl_progressive//image/test/four-square-card/cult-transform-glass-green.png" alt="" />

              <div className={style.divTxt}>
                 <div className={style.intext}>
                   <h2>care transform</h2>
                   <p>Get coached to lose weight for good</p>
                 </div>

                 <h1>></h1>
              </div>
          </div>
          <div>
              <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_400,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/four-square-card/glass-blog-multi-color.png" alt="" />
              
              <div className={style.divTxt}>
                 <div className={style.intext}>
                   <h2>The .fit way</h2>
                   <p>Making health easy, one day at a time</p>
                 </div>

                 <h1>></h1>
              </div>
         
          </div>
          <div>
              <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_400,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/four-square-card/glass-workout-gear.png" alt="" />
             
              <div className={style.divTxt1}>
                 <div className={style.intext}>
                   <h2>Workout Gear</h2>
                   <p>Everything you need for your workout</p>
                 </div>

                 <h1>></h1>
              </div>
         
          </div>
          <div>
              <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_400,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/four-square-card/sugar-fit-glass-purple.png" alt="" />
          
              <div className={style.divTxt1}>
                 <div className={style.intext}>
                   <h2>Sugar.fit</h2>
                   <p>Reverse Type 2 Diabetes and Prediabetes </p>
                 </div>

                 <h1>></h1>
              </div>
          </div>

   
       </div>
    </div>
  )
}
